<template>
    <div class="attom-title">
        <span v-html="item.title"></span>
        <help-tooltip v-if="item.helpTip" :tip="item.helpTip" :width="218" :style="tooltipStyle"></help-tooltip>
    </div>
</template>
<script>
import HelpTooltip from '@/components/help-tooltip.vue';
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        tooltipStyle() {
            return { color: 'var(--g-tip-color)' };
        }
    },
    components: {
        HelpTooltip
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
.attom-title {
    display: flex;
    align-items: baseline;
    .help-tooltip .help-tooltip-icon {
        font-size: 14px;
    }
}
</style>